import { render, staticRenderFns } from "./VinculoForm.vue?vue&type=template&id=9eb0b966&scoped=true&"
import script from "./VinculoForm.vue?vue&type=script&lang=js&"
export * from "./VinculoForm.vue?vue&type=script&lang=js&"
import style0 from "./VinculoForm.vue?vue&type=style&index=0&id=9eb0b966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb0b966",
  null
  
)

export default component.exports